import { Badge, Button, Col, Collapse, Form, FormInstance, Row } from 'antd';
import { useIntl } from 'react-intl';
import { FloatingFormItem } from '@/components/_common';
import CustomersSelectedModal from '@/components/_common/CustomersSelectedModal';
import { useDisclosure } from '@/hooks';
import {
  ReportDirectSaleSaleSummaryFormValues,
  ReportTypeEnum,
} from '@/core/domain/reports/financial/directSale/DirectSale.types';
import { useState } from 'react';
import EmployeesInfiniteSelectField from '@/components/_common/EmployeesInfiniteSelectField';
import DirectSaleTagsInfiniteSelectField from '@/components/_common/DirectSaleTagsInfiniteSelectField';

interface DirectSaleMoreOptioInterface {
  form: FormInstance<ReportDirectSaleSaleSummaryFormValues>;
}

export default function DirectSaleMoreOptions({
  form,
}: DirectSaleMoreOptioInterface) {
  const intl = useIntl().formatMessage;
  const [isOpen, setOpen] = useDisclosure(false);
  const [selectedCustomers, setSelectedCustomers] = useState<number[]>();

  const reportType = Form.useWatch('reportType', form);

  return (
    <Collapse accordion>
      <Collapse.Panel
        key="MoreOptionCollase"
        header={intl({ id: 'movementDirectSale.label.moreOptions' })}
      >
        <Row gutter={16} align="middle">
          <Col span={24} md={9}>
            <FloatingFormItem
              name="employeesIds"
              label={intl({ id: 'movementDirectSale.label.seller' })}
            >
              <EmployeesInfiniteSelectField mode="multiple" allowClear />
            </FloatingFormItem>
          </Col>

          {reportType === ReportTypeEnum.SalesTotal && (
            <Col span={24} md={9}>
              <FloatingFormItem
                name="tagsIds"
                label={intl({ id: 'movementDirectSale.label.tags' })}
              >
                <DirectSaleTagsInfiniteSelectField mode="multiple" allowClear />
              </FloatingFormItem>
            </Col>
          )}

          <Col span={24} md={6}>
            <Badge count={form.getFieldValue('customersIds')?.length}>
              <Button type="primary" onClick={setOpen.open} size="large">
                {intl({ id: 'movementDirectSale.button.selectCustomers' })}
              </Button>
            </Badge>
          </Col>
        </Row>
      </Collapse.Panel>

      <Form.Item name="customersIds" noStyle>
        <CustomersSelectedModal
          visible={isOpen}
          handleVisible={setOpen.close}
          selectedCustomerIds={selectedCustomers}
          finishCallback={(customer) => {
            setSelectedCustomers(customer);
            form.setFieldValue('customersIds', customer);
          }}
        />
      </Form.Item>
    </Collapse>
  );
}
